/**
 * Composant destiné à lister les entités .
 * Les fonctionnalités sont :
 *  - selection globale
 *  - selection par colonnes
 *  - ajouter / supprimer ds colonnes dans la liste affichée
 *  - gestion de la pagination
 *  - afficher le détail de l'entite sur le survol de sa ligne
 *  - éditer une entite pour la modifier
 *  - supprimer une entite
 *
 */
import { Component, OnInit, OnDestroy , ViewChild, AfterViewInit, ViewEncapsulation, Renderer2 } from '@angular/core';
import { animate, style, state, transition, trigger } from '@angular/animations';

import { MatTableDataSource } from '@angular/material';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

import { UserService } from '../../../services/user.service';
import { TranslateService } from '../../../services/translate.service';

import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { CommonMethods } from '../../../job/common/tools/commonMethods';
import { mjlentities_sch } from '../../../models/tables.model';
import { EntityModel } from '../../../models/user.model';

import { FieldsListService } from '../../../job/common/components/dynamic-form/fields-list.service';
import { FieldsFormgroupService } from '../../../job/common/components/dynamic-form/fields-formgroup.service';

@Component({
  selector: 'mdi-entities-table',
  templateUrl: './entities-table.component.html',
  styleUrls: ['./entities-table.component.css'],
  animations: [
    trigger('fadeInOut', [
      state('open', style({ opacity: 1 })),
      state('closed', style({ opacity: 0 })),
      transition('open <=> closed', animate('1000ms ease-in')),
    ])
  ],
  providers: [FieldsListService],
  encapsulation: ViewEncapsulation.None,
})
export class EntitiesTableComponent implements OnInit, OnDestroy, AfterViewInit {

  sidenavCollapsed = true;
  @ViewChild('sidenav', {static: false}) m_sidenav;
  dataSource = new MatTableDataSource();

  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();
  pageSize = 12;
  templateFor: string;
  // menu
  conditions: any;
  filterForm: FormGroup;
  columnsForm: FormGroup;
  opCtrl: FormControl;

  columnsChoiceCtrl: FormControl;
  forFirstValue: true;
  forSecondValue: true;
  hasNoValue: true;
  // fin menu
  // sidenav
  isFilterContent: boolean;
  isChoiceCol: boolean;
  isRegisterEntity: boolean;
  isRegisterMenu: boolean;
  doCreateEntity: boolean;
  entityToUpdate: EntityModel;
  statutRegister: any;

  loadingIndicator = true;
  reorderable = true;
  openFilters = false;

  stateFilters = 'closed';
  fields: any[];

  displayedColumns: any;

  dataColumnsName: any;
  dataColumnsDef = mjlentities_sch;
  dataColumns: any;
  selectedRowIndex: any;
  selected = [];
  cacheDatatemp = [];
  currentFilters: any;
  dateFormat: any;
  optionItem: string;
  constructor( private renderer: Renderer2,
    private _userService: UserService,
    private _translate: TranslateService,
    private _fls: FieldsListService,
    private _ffgs: FieldsFormgroupService,
    private fb: FormBuilder,
    private _currentRoute: ActivatedRoute) {
      this._translate.onLangChanged.subscribe(() => {
        this.translateLabels();
      });
      this.fields = _fls.getFields();
  }

  ngOnInit() {

    this.optionItem = 'noItem';
    this.optionItem = this._currentRoute.snapshot.data[0]['itemOption'];
    this.displayedColumns = [
      { prop: 'entity', name: this._translate.instant('entity'), isDate: false },
      { prop: 'entitylabel', name: this._translate.instant('entitylabel'), isDate: false },
      { prop: 'extendedaccess', name: this._translate.instant('extendedaccess'), isDate: false },
      { prop: 'supervisoremail', name: this._translate.instant('supervisoremail'), isDate: false },
    ];
    /// 'id', 'firstName', 'lastName', 'email', 'actions'];
    this.loadingSubject.next(true);
    this.getListEntities();
    this.conditions = CommonMethods.jsonToArray(environment.conditions);

    this.opCtrl = this.fb.control('');

    this.columnsChoiceCtrl = this.fb.control('', Validators.required);

    this.columnsForm = this.fb.group({
      columnsChoice: this.columnsChoiceCtrl,
    });
    this._ffgs.onFiltersChanged.subscribe((filters: any) => {
      this.dataSource.data = this.cacheDatatemp;
      const filtered = this.multiFilter(this.dataSource.data, filters);
      this.dataSource.data = filtered;
      this.currentFilters = filters;
    });

    this._userService.onRegisterValid.subscribe((event: any) => {
      if ((event === 'closeRegister') || (event === 'cancelRegister')) {
        this.toggleSidenav('');
        this.getListEntities();
      }
      if (event === 'deleteRegister') {
        this.getListEntities();
      }
    });

  }
  getListEntities() {
    this._userService.getEntities()
    .subscribe(
      data => {
        this.dataSource.data = data.body;
        // this.dataSource.data.sort((a: EntityModel, b: EntityModel) => a.entity - b.entity);
        this.cacheDatatemp = [...data.body];
        this.extractColumnsName(this.dataSource.data);
        this.loadingSubject.next(false);
        this.loadingIndicator = false;

      }
    );
  }
  ngOnDestroy() {

  }
  translateLabels() {

    const nbCol = this.displayedColumns.length;
    const localColumns = this.displayedColumns;
    this.displayedColumns = [];
    for (let i = 0; i < nbCol; i++) {
      const lTmp = localColumns[i];

      this.displayedColumns.push({
        'prop': lTmp.prop,
        'name': this._translate.getTranslate(lTmp.prop),
        'isDate': false
      });
    }

    this.dateFormat = this._translate.getLocalFmt('dateFormat');
  }
  extractColumnsName(_dataArray: Array<any>) {
    if (!_dataArray[0]) {
      return null;
    }

    this.dataColumnsName = Object.keys(_dataArray[0]);
    this.dataColumns = CommonMethods.optionsSelected(this._translate, this.dataColumnsDef,
      this.dataColumnsName, this.displayedColumns, false);
    // console.log('Columns current : ', this.dataColumns);
  }

  ngAfterViewInit() {


  }

  toggleSidenav(_arg: string) {

    this.isFilterContent = false;
    this.isChoiceCol = false;
    this.isRegisterEntity = false;
    this.isRegisterMenu = false;

    if (_arg === 'choiceCol') {
      this.isFilterContent = false;
      this.isChoiceCol = true;
      this.isRegisterEntity = false;
      this.isRegisterMenu = false;
    }
    if (_arg === 'registerEntity') {
      this.isFilterContent = false;
      this.isChoiceCol = false;
      this.isRegisterEntity = true;
      this.isRegisterMenu = false;
    }

    if (_arg === 'registerMenu') {
      this.isFilterContent = false;
      this.isChoiceCol = false;
      this.isRegisterEntity = false;
      this.isRegisterMenu = true;
    }
    this.sidenavCollapsed = !this.sidenavCollapsed;
    if (this.sidenavCollapsed) {
      this.m_sidenav.close();
    } else {
      this.m_sidenav.open();
    }
  }
  onSelect({ selected }) {
    // console.log('Select Event', selected, this.selected);
  }
  doAction(row: any): boolean {
    if (row.master) {
      return false;
    } else {
      return true;
    }
  }

  deleteEntity(row) {
    // console.log('deleteEntity Row clicked: ', row);

    this._userService.deleteEntity(row.entity)
      .subscribe(
        () => {
          this._userService.onRegisterValid.emit('deleteRegister');
        },
        // () => this.registrationFailed = true
      );
  }
  editMenu(row: any) {
    this.entityToUpdate = row;
    // const localDate = new Date(row.birthday);
    // console.log('date ', localDate.getDate());
    // this.userToUpdate.birthday = localDate;
    this.statutRegister = 'updateMenuEntity';
    // console.log('editEntity Row clicked: ', row);
    this.doCreateEntity = false;
    this.toggleSidenav('registerMenu');
  }
  editEntity(row: any ) {
    this.entityToUpdate = row;
    // const localDate = new Date(row.birthday);
    // console.log('date ', localDate.getDate());
    // this.userToUpdate.birthday = localDate;
    this.statutRegister = 'updateEntity';
    // console.log('editEntity Row clicked: ', row);
    this.doCreateEntity = false;
    this.toggleSidenav('registerEntity');
  }
  addEntity() {
    // console.log('addEntity : ');
    this.statutRegister = 'createEntity';
    this.doCreateEntity = true;
    this.toggleSidenav('registerEntity');
  }
  columnFilter(colName: string, filterValue: string) {
    const filters = { [colName]: [filterValue] };
    const filtered = this.multiFilter(this.dataSource.data, filters);
    // update the rows
    this.dataSource.data = filtered;
    // console.log('columnFilter: ', colName, ' : ', filterValue);
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();

    this.dataSource.data = this.cacheDatatemp;
    this.dataSource.filter = filterValue;
    /*
    const filters = { firstName: [filterValue], lastName: [filterValue] };
    const filtered = this.multiFilter(this.dataSource.data, filters);
    // update the rows
    this.dataSource.data = filtered;*/

    // Whenever the filter changes, always go back to the first page
    // this.tableCur.offset = 0;
  }
  multiFilter(array: any[], filters: Object) {
    const colType = 'login';
    return array.filter(o =>
      Object.keys(filters).every(k =>
        [].concat(filters[k]).some(v => {
          // return o[k].toLowerCase().includes(v);
          return this.filterComparator(o[k], v, k);
        }
        )
      )
    );
  }
  filterComparator(_dataValue: any, _dataFilter: any, _dataName: string): boolean {
    let dataType: string;
    this.dataColumnsDef.find(c => {
      if (c.colName === _dataName) {
        dataType = c.colType;
        return true;
      }
    });
    if (!dataType) {
      return false;
    }
    switch (dataType) {
      case 'string': {
        // console.log(_dataValue.toLowerCase(), '  ' , _dataFilter.toLowerCase());
        // return _dataValue.toLowerCase().includes(_dataFilter.toLowerCase());
        return new RegExp(_dataFilter, 'i').test(_dataValue);
      }
      case 'number': {
        return _dataValue <= _dataFilter;
      }
      default: {
        // return _dataValue.toLowerCase().includes(_dataFilter);
        return new RegExp(_dataFilter, 'i').test(_dataValue);
      }
    }

  }
  onFilterClick(templateFor: string) {
    this.templateFor = templateFor;
  }
  onFilterSubmit() {
    // console.log('onFilterSubmit ');
  }

  chkbColumnChoice(event) {
    // const checked = event.source.checked ? 'Oui' : 'Non';
    if (event.source.checked) {
      this.addColumn(event.source.id);
      this.dataColumns = CommonMethods.optionsSelected(this._translate, this.dataColumnsDef,
        this.dataColumnsName, this.displayedColumns, false);
    } else {
      this.removeColumn(event.source.id);
      this.dataColumns = CommonMethods.optionsSelected(this._translate, this.dataColumnsDef,
        this.dataColumnsName, this.displayedColumns, false);
    }
  }
  addColumn(_colAdded: string) {
    this.displayedColumns = CommonMethods.addOption(this.displayedColumns, this.dataColumnsDef, _colAdded);
    this.translateLabels();
  }
  removeColumn(_colDeleted: string) {
    this.displayedColumns = CommonMethods.removeOption(this.displayedColumns, _colDeleted);
  }

}
